import { KatLitFilteredElement, register } from '../../shared/base';
import { KatHero } from '.';

/**
 * @component {kat-hero-image} KatHeroImage Component used display hero image.
 */
@register(KatHero.slotMapping.image.name)
export class KatHeroImage extends KatLitFilteredElement {
  constructor() {
    super(KatHero.slotMapping.image.name, KatHero.slotMapping.image.allowed);
  }
}
